import { render, staticRenderFns } from "./SharedCPD.vue?vue&type=template&id=4dd53b44&scoped=true&"
import script from "./SharedCPD.vue?vue&type=script&lang=js&"
export * from "./SharedCPD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd53b44",
  null
  
)

export default component.exports